import React, { useState } from "react";
import { ModalForm } from "../../../../componentsv2/ModalForm";
import GridItem from "../../../../componentsv2/GridItem";
import DataPickerAtualizado from "../../../../components/DataPickerAtualizado";
import SelectEnfermeiro from "../SelectEnfermeiro";
import SelectHorariosDisponiveis from "../SelectHorariosDisponiveis";
import { api } from "../../../../services/Api";
import { useSnackbar } from "notistack";

function normalizarDataReagendamento(dataSelecionada) {
  const dataReferencia = dataSelecionada?.$d || dataSelecionada;
  const dataNormalizada = new Date(dataReferencia);
  dataNormalizada.setHours(0, 0, 0, 0);
  return dataNormalizada.getTime();
}

export default function ModalReagendar({ open, onClose, row }) {
  const [data, setData] = useState(new Date());
  const [hora, setHora] = useState("");
  const [enfermeiroId, setEnfermeiroId] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dados = {
        data: normalizarDataReagendamento(data),
        hora,
        enfermeiroId,
      };
      await api.patch(`v2/agendaCare/agendamento/${row.id}/reagendar`, dados);
      onClose();
      enqueueSnackbar("Reagendamento feito com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Erro ao tentar reagendar!", {
        variant: "error",
      });
    }
  };

  return (
    <ModalForm
      open={open}
      onClose={onClose}
      title="Reagendar"
      onSubmit={handleSubmit}
    >
      <GridItem xs={12}>
        <DataPickerAtualizado
          variant={"standard"}
          labelName="Data"
          required
          data={data}
          setData={setData}
        />
      </GridItem>

      <GridItem xs={6}>
        <SelectEnfermeiro
          onChange={(e) => {
            setEnfermeiroId(e.target.value);
            setHora("");
          }}
          required
        />
      </GridItem>

      <GridItem xs={6}>
        <SelectHorariosDisponiveis
          onChange={(e) => {
            setHora(e.target.value);
          }}
          data={data}
          value={hora}
          enfermeiroId={enfermeiroId}
          required
        />
      </GridItem>
    </ModalForm>
  );
}
